<!-- Production/Non-Dev Template -->
<ng-container *ngIf="!isDevEnvironment">
<div id="welcomePageContent">
    <div class="loginContainer" [ngClass]="{ 'login-full-page-view': isResetMode }">
        <div class="login-full-page-cover"></div>
        <div class="logInSection">
            <div class="text-align-center">
                <img [ngSrc]="'/assets/images/new_prism_logo.png'" class="welcome-logo" alt="ADS PRISM" height="45" width="300" />
            </div>
            <form #normalLoginForm="ngForm">
                <mat-form-field class="full-width top">
                    <input
                        matInput
                        placeholder="User Name"
                        #userInputName="ngModel"
                        required
                        [(ngModel)]="userName"
                        name="userName"
                        minlength="4"
                        (input)="removeWarning()"
                    />
                    <mat-error class="mat-error" *ngIf="userInputName.errors?.required && userInputName.touched">
                        User Name is required
                    </mat-error>
                    <mat-error class="mat-error" *ngIf="userInputName.hasError('minlength')">
                        Username should contain 4 characters
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width pad-t-6">
                    <input
                        type="password"
                        matInput
                        placeholder="Password"
                        minlength="12"
                        #passwordInput="ngModel"
                        required
                        [(ngModel)]="password"
                        name="password"
                        (input)="removeWarning()"
                    />
                    <mat-error class="mat-error" *ngIf="passwordInput.errors?.required && passwordInput.touched">
                        Password is required
                    </mat-error>
                    <mat-error class="mat-error" *ngIf="passwordInput.hasError('minlength')">
                        {{ 'COMMON.PASSWORD_LIMIT' | translate  }}
                    </mat-error>
                </mat-form-field>
                <div class="mat-error" *ngIf="isloginError">Invalid Login Credentials. Please try again.</div>
                <div class="mat-error" *ngIf="lockOutMessage">
                    You account has been locked. Please Contact customercare
                </div>

                <div class="remember-me">
                    <mat-checkbox [checked]="rememberMe" (change)="rememberMeChange($event)" matTooltip="{{ 'COMMON.REMEMBER_ME_TOOLTIP' | translate }}">
                        {{ 'COMMON.REMEMBER_ME' | translate }}
                    </mat-checkbox>
                </div>
                <div class="full-width password-login">
                    <button
                        class="full-width"
                        mat-raised-button
                        color="accent"
                        [disabled]="normalLoginForm.invalid"
                        (click)="normalLogin(userInputName.value, passwordInput.value)"
                    >
                        SIGN IN
                    </button>
                    <button class="forgot-password" mat-button (click)="forgotPassword(true)">
                        Forgot Password?
                    </button>
                </div>
            </form>
            <app-loader [isLoading]="isLoading"></app-loader>

            <button
                class="full-width signInWithMicrosoft margin-t-15"
                mat-raised-button
                color="primary"
                (click)="loginWithMicrosoft()"
            >
                <span class="microsoft"></span>
                SIGN IN WITH MICROSOFT
            </button>

            <!-- <div class="text-align-center NotRegd margin-t-15">Not Registered?</div>
                <a href="https://account.microsoft.com/account" target="_blank" rel="noopener">
                    <button class="full-width" mat-button>REGISTER NEW USER</button>
                </a> -->
        </div>
        <div class="topSection">
            <div class="headerText">Welcome to</div>
            <div class="bigText">PRISM</div>
            <div class="headerText">Proactive Insight for System Management</div>
            <div>
                <a href="http://www.adsenv.com" target="_blank" rel="noopener" mat-raised-button>LEARN MORE</a>
            </div>
        </div>
    </div>

    <div class="topSection">
        <div class="headerText">Welcome to</div>
        <div class="bigText">PRISM</div>
        <div class="headerText">Proactive Insight for System Management</div>
        <div>
            <a href="http://www.adsenv.com" target="_blank" rel="noopener" mat-raised-button>LEARN MORE</a>
            <button mat-raised-button class="contactUs" (click)="contactUs()">CONTACT US</button>
        </div>
    </div>
    <div class="contentSection">

        <!-- announcement wrapper in order to make porisition relative -->
        <div class="annoncement-wrapper" *ngIf="announcementActive">
            <div class="announcement-container">


                <!-- ANNOUNCEMENT LOGO -->
                <div class="logo-container">
                    <img [ngSrc]="'/assets/images/icons/Warning_icon.png'" height="150" width="169" />
                </div>

                <!-- NOTICE -->
                <div class="notice-header">
                    <h1>NOTICE:</h1>
                </div>

                <!-- Announcement Text -->
                <ng-container *ngIf="announcementText">
                    <div class="announcement-text">
                        <p *ngFor="let text of announcementText.split('\n'); trackBy: trackByIndex">
                            {{ text }}
                        </p>

                    </div>
                </ng-container>

            </div>
        </div>

        <mat-card class="middleSection boxShadowNone">
            <mat-card-content>
                <div>
                    <div class="headerTitle">About Us</div>
                    <div>
                        PRISM is a web application that puts critical data at your fingertips to support management,
                        engineering, and operational decisions within your wastewater collection system. PRISM connects
                        clients to an ADS monitoring network, delivering near real-time operational intelligence on the
                        status of the wastewater collection system. It is the fastest and easiest way to visualize the
                        condition of your collection system monitored by ADS sensing technology.
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <div class="headerTitle">Our Products</div>
        <mat-card class="boxShadowNone">
            <div class="prismProductContainer">
                <mat-card class="eachPrismProduct">
                    <div class="productImage prod_bg_Green">
                        <img [ngSrc]="'/assets/images/echo.png'" height="190" width="181" />
                    </div>
                    <mat-card-content>
                        <div class="productName">ECHO</div>
                        <div class="productTitle">
                            Early Overflow Detection, Surface Installation Level Monitor, and Low Cost of Ownership
                        </div>
                        <ul>
                            <li>Notification when sewer levels exceed critical thresholds</li>
                            <li>Yields up to a 5-year battery life</li>
                            <li>Provides reliable, on-demand data accessibility</li>
                            <li>Lowest purchase price and operational cost</li>
                        </ul>
                        <div style="text-align: center;">
                            <a href="https://www.adsenv.com/echo" target="_blank" rel="noopener noreferrer" aria-label="Learn more about ECHO (opens in new tab)" style="text-decoration: underline;">Learn More</a>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card class="eachPrismProduct">
                    <div class="productImage prod_bg_Orange">
                        <img [ngSrc]="'/assets/images/rain_alert.png'" height="190" width="181" />
                    </div>
                    <mat-card-content>
                        <div class="productName">Rain Alert III</div>
                        <div class="productTitle">
                            Cost Effective, Easy-to-use Rainfall Monitor for Precipitation Analysis
                        </div>
                        <ul>
                            <li>Logs and time-stamps rainfall totals at user-specified intervals down to one minute</li>
                            <li>Designed for long life and low maintenance</li>
                            <li>Get alerts via emails or text message</li>
                            <li>Nema Type 4X watertight enclosure; stainless steel hardware; mil-spec connectors</li>
                        </ul>
                        <div style="text-align: center;">
                            <a href="https://www.adsenv.com/rainalert" target="_blank" rel="noopener noreferrer" aria-label="Learn more about Rain Alert III (opens in new tab)" style="text-decoration: underline;">Learn More</a>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card class="eachPrismProduct">
                    <div class="productImage prod_bg_Yellow">
                        <img [ngSrc]="'/assets/images/Triton.png'" height="190" width="181" />
                    </div>
                    <mat-card-content>
                        <div class="productName">TRITON+</div>
                        <div class="productTitle">Industry's Most Versatile Flow Monitoring System</div>
                        <ul>
                            <li>
                                Multiple communication, power, sensor, connectivity, monitor interface, and operating
                                mode options
                            </li>
                            <li>
                                Durability, reliability, accuracy, and safety are the focus of ADS certification efforts
                            </li>
                            <li>The lowest purchase and maintenance costs for any IS monitor in the industry</li>
                            <li>Includes four multiple-technology sensor options</li>
                        </ul>
                        <div style="text-align: center;">
                            <a href="https://www.adsenv.com/triton" target="_blank" rel="noopener noreferrer" aria-label="Learn more about TRITON+ (opens in new tab)" style="text-decoration: underline;">Learn More</a>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-card>

        <div class="adsProductContainer" *ngIf="false">
            <mat-card>
                <button
                    mat-icon-button
                    (click)="previousProduct()"
                    class="previous lightBackGround"
                    matTooltip="Previous"
                >
                    <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                <div class="productContainers" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
                    <div class="adsProduct">
                        <div class="productImage">
                            <img src="../../../assets/images/echo.png" />
                        </div>
                        <div>
                            <mat-card-title>ECHO</mat-card-title>
                            <mat-card-content>
                                Early Overflow Detection, Surface Installation Level Monitor, and Low Cost of Ownership
                                <ul>
                                    <li>Notification when sewer levels exceed critical thresholds</li>
                                    <li>Yields up to a 5-year battery life</li>
                                    <li>Provides reliable, on-demand data accessibility</li>
                                    <li>Lowest purchase price and operational cost</li>
                                </ul>
                            </mat-card-content>
                        </div>
                    </div>
                    <div class="adsProduct">
                        <div class="productImage">
                            <img src="../../../assets/images/rain_alert.png" />
                        </div>
                        <div>
                            <mat-card-title>Rain Alert III</mat-card-title>
                            <mat-card-content>
                                Cost Effective, Easy-to-use Rainfall Monitor for Precipitation Analysis
                                <ul>
                                    <li>
                                        Logs and time-stamps rainfall totals at user-specified intervals down to one
                                        minute
                                    </li>
                                    <li>Designed for long life and low maintenance</li>
                                    <li>Get alerts via emails or text message</li>
                                    <li>
                                        Nema Type 4X watertight enclosure; stainless steel hardware; mil-spec connectors
                                    </li>
                                </ul>
                            </mat-card-content>
                        </div>
                    </div>
                    <div class="adsProduct">
                        <div class="productImage">
                            <img src="../../../assets/images/Triton.png" />
                        </div>
                        <div>
                            <mat-card-title>TRITON+</mat-card-title>
                            <mat-card-content>
                                Industry's Most Versatile Flow Monitoring System
                                <ul>
                                    <li>
                                        Multiple communication, power, sensor, connectivity, monitor interface, and
                                        operating mode options
                                    </li>
                                    <li>
                                        Durability, reliability, accuracy, and safety are the focus of ADS certification
                                        efforts
                                    </li>
                                    <li>
                                        The lowest purchase and maintenance costs for any IS monitor in the industry
                                    </li>
                                    <li>Includes four multiple-technology sensor options</li>
                                </ul>
                            </mat-card-content>
                        </div>
                    </div>
                </div>
                <button mat-icon-button (click)="nextProduct()" class="next lightBackGround" matTooltip="Next">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
            </mat-card>
        </div>
    </div>
</div>
</ng-container>

<!-- Development Environment Template -->
<ng-container *ngIf="isDevEnvironment">
<div id="welcomePageContent" class="dev-mode">
    <div class="loginContainer" [ngClass]="{ 'login-full-page-view': isResetMode }">
        <!-- Top Left Logo -->
        <div class="top-logo">
            <img src="/assets/images/Black%20ADS%20Logo%20with%20PRISM.png" alt="ADS PRISM" />
        </div>

        <!-- Announcement Section -->
        <div class="announcement-section" *ngIf="announcementActive">
            <div class="notice-badge">
                <mat-icon>warning</mat-icon>
                <span>NOTICE</span>
            </div>
            <div class="announcement-card">
                <div class="announcement-content">
                    <p *ngFor="let text of announcementText.split('\n'); trackBy: trackByIndex">
                        {{ text }}
                    </p>
                </div>
            </div>
        </div>

        <!-- Sign In Card -->
        <div class="logInSection">
            <div class="sign-in-header">Sign In</div>
            <form #normalLoginForm="ngForm">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>User Name</mat-label>
                    <input
                        matInput
                        placeholder="User Name"
                        #userInputName="ngModel"
                        required
                        [(ngModel)]="userName"
                        name="userName"
                        minlength="4"
                        (input)="removeWarning()"
                    />
                    <mat-error *ngIf="userInputName.errors?.required && userInputName.touched">
                        User Name is required
                    </mat-error>
                    <mat-error *ngIf="userInputName.hasError('minlength')">
                        Username should contain 4 characters
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Password</mat-label>
                    <input
                        type="password"
                        matInput
                        placeholder="Password"
                        minlength="12"
                        #passwordInput="ngModel"
                        required
                        [(ngModel)]="password"
                        name="password"
                        (input)="removeWarning()"
                    />
                    <mat-error *ngIf="passwordInput.errors?.required && passwordInput.touched">
                        Password is required
                    </mat-error>
                    <mat-error *ngIf="passwordInput.hasError('minlength')">
                        {{ 'COMMON.PASSWORD_LIMIT' | translate }}
                    </mat-error>
                </mat-form-field>

                <div class="mat-error" *ngIf="isloginError">Invalid Login Credentials. Please try again.</div>
                <div class="mat-error" *ngIf="lockOutMessage">
                    Your account has been locked. Please Contact customercare
                </div>

                <div class="remember-forgot-row">
                    <mat-checkbox [checked]="rememberMe" (change)="rememberMeChange($event)" matTooltip="{{ 'COMMON.REMEMBER_ME_TOOLTIP' | translate }}">
                        Remember Me
                    </mat-checkbox>
                    <a class="forgot-password-link" (click)="forgotPassword(true)">Forgot password?</a>
                </div>

                <button
                    type="submit"
                    class="full-width sign-in-btn"
                    mat-raised-button
                    [disabled]="normalLoginForm.invalid"
                    (click)="normalLogin(userInputName.value, passwordInput.value)"
                >
                    SIGN IN
                </button>
            </form>

            <app-loader [isLoading]="isLoading"></app-loader>

            <button
                class="full-width signInWithMicrosoft"
                mat-raised-button
                (click)="loginWithMicrosoft()"
            >
                <span class="microsoft"></span>
                SIGN IN WITH MICROSOFT
            </button>

            <div class="footer-links">
                <a href="https://www.adsenv.com/legal-notices#term" target="_blank" rel="noopener">Terms & Conditions</a>
                <a href="https://www.adsenv.com/legal-notices#privacy" target="_blank" rel="noopener">Privacy Policy</a>
                <a (click)="contactUs()">Contact Us</a>
            </div>
        </div>

        <!-- Bottom Left Content -->
        <div class="bottom-content">
            <div class="tagline">Proactive Insight for System Management</div>
            <p class="description">
                PRISM delivers near real-time insights into wastewater, stormwater, and flooding conditions, enabling proactive collection system management.
            </p>
            <div class="copyright">&copy; 2026 ADS LLC.  All Rights Reserved.</div>
        </div>

        <!-- Bottom Right IDEX Logo -->
        <div class="idex-logo">
            <img src="/assets/images/IDEX%20IW%20logo.png" alt="IDEX Intelligent Water" />
        </div>
    </div>
</div>
</ng-container>
